// Suggestion chips: exactly 3 non-empty strings, else none (D191). The server
// sends 0 or 3; anything else is treated as a failure and renders no buttons.
export const acceptSuggestions = (raw: unknown): string[] =>
  Array.isArray(raw) &&
  raw.length === 3 &&
  raw.every((s) => typeof s === 'string' && s.trim().length > 0)
    ? (raw as string[])
    : [];
